const pgcetmbaAnalyticalReasoning = [
  {
    id: 21,
    question: "Find the next number in the series: 3, 8, 15, 24, 35, ?",
    options: ["A. 46", "B. 48", "C. 49", "D. 50"],
    answer: "B"
  },
  {
    id: 22,
    question: "Find the next letter in the series: B, E, H, K, ?",
    options: ["A. M", "B. O", "C. N", "D. L"],
    answer: "C"
  },
  {
    id: 23,
    question: "If A = 1, B = 2, C = 3 and so on up to Z = 26, what is the sum of the letter values of the word BAG?",
    options: ["A. 10", "B. 11", "C. 9", "D. 12"],
    answer: "A"
  },
  {
    id: 24,
    question: "In a certain code language, LEMON is written as NOMEL. How will HOUSE be written in that code?",
    options: ["A. ESOUH", "B. EUSOH", "C. HSUOE", "D. ESUOH"],
    answer: "D"
  },
  {
    id: 25,
    question: "Pointing to a man, Riya said, \"He is the only son of my mother's husband.\" How is the man related to Riya?",
    options: ["A. Father", "B. Cousin", "C. Uncle", "D. Brother"],
    answer: "D"
  },
  {
    id: 26,
    question: "A is the father of B. C is the sister of A. D is the son of C. How is D related to B?",
    options: ["A. Cousin", "B. Brother", "C. Nephew", "D. Uncle"],
    answer: "A"
  },
  {
    id: 27,
    question: "Kiran walks 15 m towards the north, turns right and walks 8 m. How far is he from his starting point?",
    options: ["A. 23 m", "B. 7 m", "C. 17 m", "D. 15 m"],
    answer: "C"
  },
  {
    id: 28,
    question: "A girl is facing east. She turns 90° clockwise, then 180° anticlockwise and then 45° clockwise. In which direction is she facing now?",
    options: ["A. North-West", "B. North-East", "C. South-East", "D. South-West"],
    answer: "B"
  },
  {
    id: 29,
    question: "Statements: All mangoes are fruits. Some fruits are sour. Conclusions: I. Some mangoes are sour. II. Some sour things are fruits.",
    options: ["A. Only conclusion I follows", "B. Only conclusion II follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "B"
  },
  {
    id: 30,
    question: "Statements: All managers are graduates. No graduate is illiterate. Conclusions: I. No manager is illiterate. II. Some graduates are managers.",
    options: ["A. Only conclusion I follows", "B. Only conclusion II follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "C"
  },
  {
    id: 31,
    question: "Five friends P, Q, R, S and T sit in a row facing north. R sits in the middle. P sits at the extreme left end. T sits immediately to the right of R. Q does not sit next to R. Who sits between P and R?",
    options: ["A. Q", "B. T", "C. No one", "D. S"],
    answer: "D"
  },
  {
    id: 32,
    question: "In a row of 40 students, Meena is 14th from the left end. What is her position from the right end?",
    options: ["A. 26th", "B. 27th", "C. 25th", "D. 28th"],
    answer: "B"
  },
  {
    id: 33,
    question: "Nurse : Hospital :: Teacher : ?",
    options: ["A. School", "B. Student", "C. Book", "D. Library"],
    answer: "A"
  },
  {
    id: 34,
    question: "8 : 64 :: 11 : ?",
    options: ["A. 111", "B. 132", "C. 121", "D. 144"],
    answer: "C"
  },
  {
    id: 35,
    question: "Find the odd one out.",
    options: ["A. 27", "B. 64", "C. 125", "D. 150"],
    answer: "D"
  },
  {
    id: 36,
    question: "Find the odd one out.",
    options: ["A. Mercury", "B. Venus", "C. Moon", "D. Mars"],
    answer: "C"
  },
  {
    id: 37,
    question: "Statement: \"The company has announced a 20% discount on all its products to increase sales during the festive season.\" Assumptions: I. Customers tend to buy more when discounts are offered. II. Competitors of the company will not offer any discount.",
    options: ["A. Only assumption I is implicit", "B. Only assumption II is implicit", "C. Both I and II are implicit", "D. Neither I nor II is implicit"],
    answer: "A"
  },
  {
    id: 38,
    question: "What is the present age of Ramesh? Statement I: Ramesh is 5 years older than Suresh. Statement II: Suresh's age is one-third of his father's age, and his father is 60 years old.",
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Either statement alone is sufficient",
      "D. Both statements together are necessary"
    ],
    answer: "D"
  },
  {
    id: 39,
    question: "What is the angle between the hour hand and the minute hand of a clock at 4:20?",
    options: ["A. 0°", "B. 10°", "C. 20°", "D. 5°"],
    answer: "B"
  },
  {
    id: 40,
    question: "If 1 January 2023 was a Sunday, what day of the week was 1 January 2024?",
    options: ["A. Monday", "B. Tuesday", "C. Sunday", "D. Saturday"],
    answer: "A"
  }

];

export default pgcetmbaAnalyticalReasoning;
